// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --gallery-accent: #7774ff;
  display: block;
  height: 100%;
}

.gallery-content {
  --background: #101116;
  --overflow: hidden;
}

.gallery-shell {
  position: relative;
  display: grid;
  width: 100%;
  height: 100%;
  min-height: 100%;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr) auto auto;
  overflow: hidden;
  color: #ffffff;
  background: radial-gradient(circle at 50% 42%, rgba(88, 85, 130, 0.3), transparent 45%), #101116;
}

.gallery-header {
  z-index: 20;
  display: grid;
  min-width: 0;
  padding: calc(12px + env(safe-area-inset-top)) 14px 12px;
  grid-template-columns: 44px minmax(0, 1fr) 44px;
  gap: 12px;
  align-items: center;
  background: rgba(16, 17, 22, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(18px);
}

.gallery-heading {
  min-width: 0;
  text-align: center;
}

.gallery-heading strong,
.gallery-heading span {
  display: block;
}

.gallery-heading strong {
  overflow: hidden;
  font-size: 14px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gallery-heading span {
  margin-top: 3px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 10px;
  font-weight: 700;
}

.gallery-control,
.navigation-button {
  display: grid;
  padding: 0;
  place-items: center;
  color: #ffffff;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  backdrop-filter: blur(12px);
}

.gallery-control {
  width: 44px;
  height: 44px;
}

.gallery-control ion-icon {
  font-size: 21px;
}

.header-balance {
  width: 44px;
  height: 44px;
}

.gallery-stage {
  position: relative;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.carousel-wrapper {
  display: flex;
  width: 100%;
  min-width: 0;
  height: 100%;
  transition: transform 280ms cubic-bezier(0.22, 0.61, 0.36, 1);
  will-change: transform;
}

.carousel-item {
  display: flex;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 100%;
  margin: 0;
  padding: 12px 8px;
  flex: 0 0 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.carousel-item img {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  filter: drop-shadow(0 18px 30px rgba(0, 0, 0, 0.3));
}

.navigation-button {
  position: absolute;
  top: 50%;
  width: 42px;
  height: 54px;
  z-index: 10;
  transform: translateY(-50%);
}

.navigation-button ion-icon {
  font-size: 24px;
}

.navigation-button.previous {
  left: 10px;
}

.navigation-button.next {
  right: 10px;
}

.gallery-footer {
  z-index: 20;
  width: 100%;
  min-width: 0;
  padding: 10px 14px calc(12px + env(safe-area-inset-bottom));
  overflow: hidden;
  background: rgba(16, 17, 22, 0.92);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(18px);
}

.gallery-caption {
  min-width: 0;
  max-height: 100px;
  margin: 0;
  padding: 10px 16px;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-line;
  background: rgba(16, 17, 22, 0.92);
}

.description-control {
  display: grid;
  width: 100%;
  min-height: 38px;
  padding: 0 10px;
  grid-template-columns: 20px minmax(0, 1fr) 18px;
  gap: 8px;
  align-items: center;
  color: rgba(255, 255, 255, 0.84);
  font-size: 11px;
  font-weight: 800;
  text-align: left;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.07);
  border: 0;
  border-radius: 11px;
}

.description-control ion-icon:first-child {
  color: #aaa8ff;
  font-size: 17px;
}

.image-description {
  max-height: 100px;
  margin: 8px 2px 0;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
  line-height: 1.5;
}

.thumbnail-track {
  display: flex;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  gap: 8px;
  margin-top: 9px;
  padding-bottom: 1px;
  overflow-x: auto;
  scrollbar-width: none;
}

.thumbnail-track::-webkit-scrollbar {
  display: none;
}

.thumbnail-track button {
  width: 48px;
  height: 48px;
  padding: 2px;
  flex: 0 0 48px;
  overflow: hidden;
  cursor: pointer;
  background: transparent;
  border: 2px solid transparent;
  border-radius: 11px;
  opacity: 0.56;
  transition: opacity 140ms ease, border-color 140ms ease, transform 140ms ease;
}

.thumbnail-track button.active {
  border-color: var(--gallery-accent);
  opacity: 1;
  transform: translateY(-1px);
}

.thumbnail-track img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 7px;
}

@media (min-width: 760px) {
  .carousel-item {
    padding: 24px 74px;
  }
  .gallery-footer {
    padding-right: 24px;
    padding-left: 24px;
  }
  .thumbnail-track {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/component/gallery-modal/gallery-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,iDAAA;EACA,gBAAA;EACA,cAAA;EACA,gGAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,wDAAA;EACA,+CAAA;EACA,SAAA;EACA,mBAAA;EACA,iCAAA;EACA,kDAAA;EACA,2BAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6DAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;EACA,gBAAA;EACA,kCAAA;EACA,+CAAA;EACA,2BAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kCAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,+CAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,6EAAA;AACF;;AAEA;EACE,mCAAA;EACA,UAAA;EACA,2BAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,kBAAA;EACF;EAEA;IACE,mBAAA;IACA,kBAAA;EAAF;EAGA;IACE,uBAAA;EADF;AACF","sourcesContent":[":host {\n  --gallery-accent: #7774ff;\n  display: block;\n  height: 100%;\n}\n\n.gallery-content {\n  --background: #101116;\n  --overflow: hidden;\n}\n\n.gallery-shell {\n  position: relative;\n  display: grid;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n  min-width: 0;\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: auto minmax(0, 1fr) auto auto;\n  overflow: hidden;\n  color: #ffffff;\n  background: radial-gradient(circle at 50% 42%, rgba(88, 85, 130, 0.3), transparent 45%), #101116;\n}\n\n.gallery-header {\n  z-index: 20;\n  display: grid;\n  min-width: 0;\n  padding: calc(12px + env(safe-area-inset-top)) 14px 12px;\n  grid-template-columns: 44px minmax(0, 1fr) 44px;\n  gap: 12px;\n  align-items: center;\n  background: rgba(16, 17, 22, 0.9);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(18px);\n}\n\n.gallery-heading {\n  min-width: 0;\n  text-align: center;\n}\n\n.gallery-heading strong,\n.gallery-heading span {\n  display: block;\n}\n\n.gallery-heading strong {\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gallery-heading span {\n  margin-top: 3px;\n  color: rgba(255, 255, 255, 0.62);\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.gallery-control,\n.navigation-button {\n  display: grid;\n  padding: 0;\n  place-items: center;\n  color: #ffffff;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 14px;\n  backdrop-filter: blur(12px);\n}\n\n.gallery-control {\n  width: 44px;\n  height: 44px;\n}\n\n.gallery-control ion-icon {\n  font-size: 21px;\n}\n\n.header-balance {\n  width: 44px;\n  height: 44px;\n}\n\n.gallery-stage {\n  position: relative;\n  width: 100%;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.carousel-wrapper {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  transition: transform 280ms cubic-bezier(0.22, 0.61, 0.36, 1);\n  will-change: transform;\n}\n\n.carousel-item {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 12px 8px;\n  flex: 0 0 100%;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.carousel-item img {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  height: 100%;\n  min-height: 0;\n  max-height: 100%;\n  object-fit: contain;\n  object-position: center;\n  filter: drop-shadow(0 18px 30px rgba(0, 0, 0, 0.3));\n}\n\n.navigation-button {\n  position: absolute;\n  top: 50%;\n  width: 42px;\n  height: 54px;\n  z-index: 10;\n  transform: translateY(-50%);\n}\n\n.navigation-button ion-icon {\n  font-size: 24px;\n}\n\n.navigation-button.previous {\n  left: 10px;\n}\n\n.navigation-button.next {\n  right: 10px;\n}\n\n.gallery-footer {\n  z-index: 20;\n  width: 100%;\n  min-width: 0;\n  padding: 10px 14px calc(12px + env(safe-area-inset-bottom));\n  overflow: hidden;\n  background: rgba(16, 17, 22, 0.92);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(18px);\n}\n\n.gallery-caption {\n  min-width: 0;\n  max-height: 100px;\n  margin: 0;\n  padding: 10px 16px;\n  overflow-y: auto;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 12px;\n  line-height: 1.5;\n  white-space: pre-line;\n  background: rgba(16, 17, 22, 0.92);\n}\n\n.description-control {\n  display: grid;\n  width: 100%;\n  min-height: 38px;\n  padding: 0 10px;\n  grid-template-columns: 20px minmax(0, 1fr) 18px;\n  gap: 8px;\n  align-items: center;\n  color: rgba(255, 255, 255, 0.84);\n  font-size: 11px;\n  font-weight: 800;\n  text-align: left;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.07);\n  border: 0;\n  border-radius: 11px;\n}\n\n.description-control ion-icon:first-child {\n  color: #aaa8ff;\n  font-size: 17px;\n}\n\n.image-description {\n  max-height: 100px;\n  margin: 8px 2px 0;\n  overflow-y: auto;\n  color: rgba(255, 255, 255, 0.76);\n  font-size: 11px;\n  line-height: 1.5;\n}\n\n.thumbnail-track {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  gap: 8px;\n  margin-top: 9px;\n  padding-bottom: 1px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.thumbnail-track::-webkit-scrollbar {\n  display: none;\n}\n\n.thumbnail-track button {\n  width: 48px;\n  height: 48px;\n  padding: 2px;\n  flex: 0 0 48px;\n  overflow: hidden;\n  cursor: pointer;\n  background: transparent;\n  border: 2px solid transparent;\n  border-radius: 11px;\n  opacity: 0.56;\n  transition: opacity 140ms ease, border-color 140ms ease, transform 140ms ease;\n}\n\n.thumbnail-track button.active {\n  border-color: var(--gallery-accent);\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\n.thumbnail-track img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 7px;\n}\n\n@media (min-width: 760px) {\n  .carousel-item {\n    padding: 24px 74px;\n  }\n\n  .gallery-footer {\n    padding-right: 24px;\n    padding-left: 24px;\n  }\n\n  .thumbnail-track {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
